// Step 23 — contract findings.
//
// Reuses the Step-19 AIFindingCard verbatim so contract findings look
// identical to buyer / risk / preparedness findings elsewhere. All
// finding shapes come from `contractFindingsFromDetail` — no new
// logic, no invented severities or scores.

import AIFindingCard from "../intelligence/AIFindingCard";
import { AIEmpty, AISection } from "../AIPrimitives";
import { contractFindingsFromDetail } from "./helpers";

export default function AIContractFindings({ detail, workspaceId }) {
  const findings = contractFindingsFromDetail(detail);
  if (findings.length === 0) {
    return (
      <AISection title="Fynd">
        <AIEmpty
          title="Inga öppna kontraktsfynd"
          hint="Utkastet är antingen komplett eller redan hanterat av en människa."
        />
      </AISection>
    );
  }
  return (
    <AISection
      title="Fynd"
      right={
        <span className="qai-page-section-hint">
          {findings.length} post{findings.length === 1 ? "" : "er"}
        </span>
      }
    >
      <div className="qai-attention-queue">
        {findings.map((f) => (
          <AIFindingCard key={f.key} finding={f} workspaceId={workspaceId} />
        ))}
      </div>
    </AISection>
  );
}
